import React from 'react';
import useStyles from './styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import BackgroundImage from '../../components/BackgroundImage';

const PaymentLinkExpireMsg = ({ errorCode, logoImage, paymentInfo, transactionId }) => {

    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <>
            {errorCode && (
                <Grid container justifyContent="center">
                    <Grid item md={5}>
                        <Card className={classes.root}>
                            <CardActionArea>
                                {logoImage && (
                                    <div className={classes.logo}>
                                        <img src={logoImage} alt="logo" className={classes.logoImg} />
                                    </div>
                                )}
                                <BackgroundImage src={paymentInfo?.companyStyle?.backgroundPicture || ''} />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="h2">
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary" component="p">
                                        <Alert className={classes.AlertMessage} severity="warning">
                                            {t(errorCode)} - {transactionId}
                                            {/*{', '} {t('expireLinkText', { paymentInfo })}*/}
                                        </Alert>
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            )}
        </>
    );
};

export default PaymentLinkExpireMsg;






